import React from 'react'
import { Link } from 'gatsby'
import { PrismicProvider } from '@prismicio/react'
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews'

// Auth
import { AuthProvider } from './src/auth'

// Utils
import htmlSerializer from './src/utils/htmlSerializer'
import { repositoryConfigs } from './src/utils/prismicPreviews'

// CSS
import '@fontsource-variable/inter'
import './src/styles/default.css'

export const wrapRootElement = ({ element }) => (
  <AuthProvider>
    <PrismicProvider
    externalLinkComponent={({ href, className, ...props }) => {
      if (href.includes('mobilitybroker24.com')) {
        return (
          <a data-location='internal' href={href} target='_self' className={className}>
            {props.children}
          </a>
        )
      }
      return (
        <a data-location='external' href={href} target='_blank' rel='noreferrer' className={className} {...props}>
          {props.children}
        </a>
      )
    }}
    internalLinkComponent={({ href, ...props }) => {
      if (href.includes('auction')) {
        return (
          <a data-location='auction' href={href} {...props}>
            {props.children}
          </a>
        )
      }
      return <Link to={href} {...props} />
    }}
    richTextComponents={htmlSerializer}>
    <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>{element}</PrismicPreviewProvider>
  </PrismicProvider>
  </AuthProvider>
)
